<template>
  <div>
    <div v-if="showCategoryLink && showSubCategoryLink">
      <div
        v-if="showSubCategoryLink"
        :typeBtn="'clearBtn text-xs-right'"
       
      >
        <div class="mr-2">
          <span class="black--text">המערכת איתרה עבורך</span>
          <span class="primary--text">{{ subCategoriesSuggestionsCount }}</span>
          <span class="black--text">משרות נוספות בתחום</span>

          <nuxt-link
            v-for="(suggestion, index) in subCategorySuggestion"
            :key="index"
            :to="`/jobs/subcat/${subCategorySuggestion[index].Item.Code}`"
          >
            <span class="primary--text">{{ subCategorySuggestion[index].Item.NameInHebrew }}</span>
            <span v-if="notLastElement( subCategorySuggestion, index)" class="no-underline-gap">,</span>
          </nuxt-link>
        </div>
      </div>

      <div
        v-if="showCategoryLink"
        :typeBtn="'clearBtn text-xs-right'"       
      >
        <div class="mr-2">
          <span class="black--text">ועוד</span>
          <span class="primary--text">{{ categorySuggestion[0].JobCount.toLocaleString() }}</span>
          <span class="black--text">משרות נוספות בקטגוריה</span>
          <nuxt-link :to="`/jobs/cat${categoryLink}`">
            <span class="primary--text">{{ categorySuggestion[0].Item.NameInHebrew }}</span>
          </nuxt-link>
        </div>
      </div>
    </div>

    <div v-else-if="showCategoryLink && !showSubCategoryLink">
      <div :typeBtn="'clearBtn text-xs-right'">
        <div class="mr-2">
          <span class="black--text">המערכת איתרה עבורך</span>
          <span class="primary--text">{{ categorySuggestion[0].JobCount.toLocaleString() }}</span>
          <span class="black--text">משרות נוספות בקטגוריה</span>
          <nuxt-link :to="`/jobs/cat${categoryLink}`">
            <span class="primary--text">{{ categorySuggestion[0].Item.NameInHebrew }}</span>
          </nuxt-link>
        </div>
      </div>
    </div>

    <div v-else-if="showSubCategoryLink && !showCategoryLink">
      <div :typeBtn="'clearBtn text-xs-right'" >
        <div class="mr-2">
          <span class="black--text">המערכת איתרה עבורך</span>
          <span class="primary--text">{{subCategoriesSuggestionsCount }}</span>

          <span class="black--text">משרות נוספות בתחום</span>

          <nuxt-link
            v-for="(suggestion, index) in subCategorySuggestion"
            :key="index"
            :to="`/jobs/subcat/${subCategorySuggestion[index].Item.Code}`"
          >
            <span class="primary--text">{{ subCategorySuggestion[index].Item.NameInHebrew }}</span>
            <span v-if="notLastElement(subCategorySuggestion, index)" class="no-underline-gap">,</span>
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reduce, size } from 'lodash'

export default {
  props: {
    showSubCategoryLink: {
      type: Boolean
    },

    showCategoryLink: {
      type: Boolean
    },

    categorySuggestion: {
      type: Object
    },

    subCategorySuggestion: {
      type: Object
    },

    categoryLink: {
      type: Number
    },

    subCategoryLink: {
      type: Number
    }
  },

  computed: {
    subCategoriesSuggestionsCount() {
      return reduce(
        this.subCategorySuggestion,
        function(sum, e) {
          return sum + e.JobCount
        },
        0
      )
    }
  },

  methods: {
    notLastElement(object, index) {
      return size(object) - 1 != index ? true : false
    }
  }
}
</script>

<style scoped>
.no-underline-gap {
  text-decoration: none !important;
  padding: 2px;
}
</style>
